export default "__VITE_ASSET__4nqWfWtc__"